<div>
  <div class="modal-header customBlueHeader">
    <p class="modal-title">Logout Confirm</p>
    <button type="button" aria-label="Close" class="close" (click)="closePopup()">
      <!-- <span aria-hidden="true">×</span> -->
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body customModalBody">
    <div>You are redirecting to Login Page</div>
  </div>
  <div class="modal-footer customModalFooter">
    <!--<div class="pull-right">-->
      <button type="button" class="btn danger_btn" (click)="closePopup()">Cancel</button>
      <button type="button" class="btn green_btn" (click)="redictLoginPage()">Ok</button>
    <!--</div>-->
  </div>

</div>
